import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { ExternalAuthService } from './external-auth.service';

@Injectable({
  providedIn: 'root',
})
export class LogsAccessGuard {
  constructor(
    private externalAuthService: ExternalAuthService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    const role = this.externalAuthService.getCurrentUserInfo()?.role;
    if (role === 'admin' || role === 'it' || role === 'logs') {
      return true;
    }
    return this.router.parseUrl('/companies/list');
  }
}
